import React from 'react';
import PropTypes from 'prop-types';
import { ShowButton, Datagrid, TextField, DateField, Filter, TextInput, SelectInput, DateInput } from 'react-admin';
import AmountField from '../../components/fields/AmountField';
import TList from '../../components/wrapper/TList';
import { coreWalletPaymentTransactionStatusForSelection } from '../paymentTransactions/PaymentTransactionConstants';
import { coreWalletUnmatchedPaymentStatusForSelection } from './UnmatchedPaymentConstants';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';
import UnmatchedPaymentListActions from './UnmatchedPaymentListActions';

const UnmatchedPaymentFilter = ({ unmatchedPaymentStatusForSelection, paymentTransactionStatusForSelection, ...props }) => (
	<Filter {...props}>
		<SelectInput
			resettable
			label="resources.unmatchedPayments.filters.unmatchedPaymentStatus"
			source="unmatchedPaymentStatus"
			choices={unmatchedPaymentStatusForSelection}
		/>
		<SelectInput
			resettable
			label="resources.unmatchedPayments.filters.oldStatus"
			source="oldStatus"
			choices={paymentTransactionStatusForSelection}
		/>
		<SelectInput
			resettable
			label="resources.unmatchedPayments.filters.newStatus"
			source="newStatus"
			choices={paymentTransactionStatusForSelection}
		/>
		<TextInput
			resettable
			label="resources.unmatchedPayments.filters.resolverType"
			source="resolverType"
		/>
		<TextInput
			resettable
			label="resources.unmatchedPayments.filters.resolverId"
			source="resolverId"
		/>
		<DateInput
			source="fromDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<DateInput
			source="untilDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
	</Filter>
);

const UnmatchedPaymentList = ({ unmatchedPaymentStatusForSelection, paymentTransactionStatusForSelection, ...props }) => (
	<TList
		{...props}
		actions={<UnmatchedPaymentListActions />}
		filters={
			<UnmatchedPaymentFilter
				unmatchedPaymentStatusForSelection={unmatchedPaymentStatusForSelection}
				paymentTransactionStatusForSelection={paymentTransactionStatusForSelection}
				/>
		}
	>
		<Datagrid>
			<ShowButton />
			<TextField source="id" sortable={false} />
			<DateField source="creationDateTime" showTime sortable={false} />
			<TextField source="unmatchedPaymentStatus" sortable={false} />
			<DateField source="resolveDateTime" showTime sortable={false} />
			<TextField source="description" sortable={false} />
			<AmountField source="paymentTransactionData.amount" sortable={false} />
			<TextField source="paymentTransactionData.subject" sortable={false} />
		</Datagrid>
	</TList>
);

UnmatchedPaymentList.propTypes = {
	unmatchedPaymentStatusForSelection: PropTypes.array.isRequired,
	paymentTransactionStatusForSelection: PropTypes.array.isRequired
};
UnmatchedPaymentList.defaultProps = {
	unmatchedPaymentStatusForSelection: coreWalletUnmatchedPaymentStatusForSelection,
	paymentTransactionStatusForSelection: coreWalletPaymentTransactionStatusForSelection
};

export default UnmatchedPaymentList;
